import type { ParticipantId } from "../types/common";
import type { KineticCoreConfig } from "../types/game-config";
import type { KineticCoreState } from "../types/game-state";
import { countRemaining } from "../utils/entity-helpers";
import { getOpponentId } from "../utils/participant-helpers";

export function evaluateOutcome(
  state: KineticCoreState,
  actingParticipant: ParticipantId,
  config: KineticCoreConfig,
): KineticCoreState {
  const opponent = getOpponentId(state.participants, actingParticipant);
  const actorCount = countRemaining(state.entities, actingParticipant);
  const opponentCount = countRemaining(state.entities, opponent);

  if (actorCount === 0 && opponentCount === 0) {
    return {
      ...state,
      phase: "ENDED",
      winner: opponent,
      outcomeReason: "BOTH_ELIMINATED",
    };
  }

  if (opponentCount === 0) {
    return {
      ...state,
      phase: "ENDED",
      winner: actingParticipant,
      outcomeReason: "ALL_ELIMINATED",
    };
  }

  if (actorCount === 0) {
    return {
      ...state,
      phase: "ENDED",
      winner: opponent,
      outcomeReason: "SELF_ELIMINATED",
    };
  }

  if (state.turn >= config.maxTurns) {
    if (actorCount > opponentCount) {
      return {
        ...state,
        phase: "ENDED",
        winner: actingParticipant,
        outcomeReason: "TURN_LIMIT",
      };
    }

    if (opponentCount > actorCount) {
      return {
        ...state,
        phase: "ENDED",
        winner: opponent,
        outcomeReason: "TURN_LIMIT",
      };
    }

    return {
      ...state,
      phase: "ENDED",
      winner: null,
      outcomeReason: "TURN_LIMIT",
      isDraw: true,
    };
  }

  return state;
}
